export const customize = {
    showPreviewImage: false,
    showFromPrice: false, // hotfix for sofaworx
    inlineOptions: true,
    visibleBackToList: false
}

export const quantityCustom =
{
    visible: false,
    messageMultiplier: false,
    messageMininum: false,
    messageUnit: false
}
//visible all product
export const askAQuestionForm =
{
    visible: false,
    email: "damy@retailsystem.com",
}

export const customizeModalButton =
{
    title: "Customize Your Product",
}

export const productListCustomise =
{
    title: "Customise",
}

export const productStockLabel =
{
    title: "IN STOCK",
}

export const bigFurnitureShow = false;

export const digitalagent = false;

export const isKiosk = false;

export const isBrochure = false;

export const brochureWishlistCookie = {
    WISHLIST_COOKIE_NAME: 'localWishlist', // name of the cookie storing the product list
    WISHLIST_DURATION: 60 * 1000 * 20, // time (milliseconds) until the wishlist is emptied
}

export const multiStore = false;

export const showPriceOptions = true;

export const paymentJustNow = false;

export const paymentJustNowQuota = 3;

export const showPriceRangeFilter = true; //*BFS false

export const wishlistButton = {
    showInDetail: false,
    showInProductCard: false
}

export const sectionAskAQuestion = false;

export const brandPhoneNumberAvailable = false;

export const stockSectionWithoutNumber =
{
    enabled: false,
    text: ''
}

export const showAcceptTermsAndConditions =
{
    visible: false,
    url: "",
}

export const showOptionTextHover = true;

export const showImageAtCustomizeSelection = false;

export const disabledAddToBasket = false;

//dropdown customer accounts in cart
export const showDropDownCustomerAccounts = {
    visible: false,
    messageError: "Contact the administrator for more information",
}

//app Affirm for buy promotions
export const activeAffirmApp = {
    show: false,
    key: 'EG7Q73BW7KXM6G69'
};

export const myRegistryApp = {
    show: false,
    url: ''
}

//when custom is false :  You must callforprice and shopSettings.askForPriceDefaultForm true, use the database template email
//when custom is true :  You must create your own form and send the email in SetupProductRequestForm
export const customProductRequestForm =
{
    custom: false,
    recipient: "damy@retailsystem.com",//only use custom true
}
export const showNameRange = true; //true: show product range name, false: show "View entire range"

//true: product detail use component SetupDescriptionProduct
export const useSetupDescription = false;


export const leadtime = {
    text: 'Availability'
};

export const bulletsPrductoList = {
    enabled: false
};

export const buttonBackToTop = {
    productDetailEnabled: false,
    productListEnabled: false,
    ivl: false,
    allSite: false,
};

export const availabilityOptionsOnCard = {
    typeOfMaterialEnabled: false, // enable to display inLeather and inFabric options on product card
    optionsCarouselEnabled: false, // enable to display the fabric and leather image carousel on product card
}

export const availabilityOptionsOnProductInfo = false; // enable to display inLeather and inFabric options on product page


export const wishlistButtonNextTitle = false;//button next to title product
export const wishListTitle = "Buyers List"; // Title page wishlist 
export const routeWishList = "/buyerslist"; // Title page wishlist 


//klarna on-site messaging
export const klarnaMessaging = {
    show: false,
    key: '3cf44ede-1514-5d53-a3ad-97759c3c3047',
    dataLocale: "en-GB"
};
//all finance
export const setupCustomFinance = {
    enabled: false,
};

export const showPriceSaleWithDetailText = {
    enabled: false,
    oldPriceText: '',
    nowPriceText: '',
};

export const showTextNextToLowestPrice = {
    enabled: false, // enable to show only the lowest price of the price range
    text: '', // optional text to add next to the lowest price
};


export const setupCustomSectionOption = {
    enabled: false,
};



export const sectionRecommendedProducts = {
    enabled: true, //TRUE default
    title: "You May Also Like",
    readAll: false,
    readAllText: "VIEW ALL",
};

export const setupSectionBelow = {
    enabled: false,
};


export const sharedButtons = {
    enabled: false,
};

export const askForPriceLabelText = {
    enabled: false,
    default: "Ask for price"
};

export const backButtonNextToBreadcrumb = {
    enabled: false,
    text: "Back"
};

export const showOldPriceCustomizeModal = false;

export const sotckOptionUserLetter = true;

export const stockRequestInfo = {
    enabled: false,
    request: 'https://api.retailsystem.io/ws/Product/StockIsAvailable/',
    update: 'https://api.retailsystem.io/ws/Product/UpdateStockAvailability/'
}


export const productWithoutStockLabel =
{
    enabled: false,
    title: "AVAILABLE TO ORDER",
}

export const comments = {
    enabled: false,
    apiToken: "H1lnaC-NpTfpQ86fHbjSAFrI1kk",
    shopDomain: "online-and-direct-ws.myshopify.com",
    platform: "shopify",
    baseUrl: "https://judge.me/api/v1/",
    ratings: "",//query params filter, ex: 5
    title: "Reviews for product",
    text:"Leave your comment about this product and help us improve.",
    buttonText:"Write a review",
    buttonTextLogin:"Log in to share your experience"
}


//price in the product listing
export const roundNumberProductList =
{
    rounding: 2 //number of decimal places after the comma
}

export const inStockReadyToDeliver = {
    enable: false,
    text: "In stock - Ready to deliver"
}

export const customBannerPDP = {
    enabled: false,
    src: '',
    mobile: ''
}